var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 0.625L20.2826 8.35375L29.2664 10.99L23.5476 18.4025L23.8164 27.76L15.0001 24.6125L6.18389 27.76L6.45264 18.4025L0.733887 10.99L9.71764 8.35375L15.0001 0.625ZM12.5001 15H10.0001C10.0001 16.3044 10.5099 17.5572 11.4206 18.4911C12.3314 19.4249 13.5711 19.9659 14.8751 19.9985C16.1791 20.0311 17.4443 19.5528 18.4006 18.6657C19.3569 17.7786 19.9287 16.5528 19.9939 15.25L20.0001 15H17.5001C17.503 15.6487 17.2537 16.2732 16.8047 16.7414C16.3557 17.2097 15.7422 17.4851 15.094 17.5094C14.4457 17.5338 13.8133 17.3052 13.3305 16.8719C12.8477 16.4386 12.5521 15.8346 12.5064 15.1875L12.5001 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReating);
export default __webpack_public_path__ + "static/media/Reating.9721af299739a9c8f089cb7aeaa6347c.svg";
export { ForwardRef as ReactComponent };